<template>
    <div>
        <p>
            Name: {{item.name}}<br>
            URL: {{item.path}}
            <routes-list-items :children="item.children"></routes-list-items>
        </p>
    </div>
</template>

<script>
    import RoutesListItems from './RoutesListItems';
    export default {
        components: {
            RoutesListItems
        },
        name: 'routesList',
        props: [
            'item'
        ]
    };
</script>



// WEBPACK FOOTER //
// src/views/Debug/Routes/RoutesList.vue